module.exports = __webpack_public_path__ + "img/backspace-reverse.8ff8abff.svg";